import { defineStore } from 'pinia';

export interface DeviceStateInterface {
  isKeyboardVisible: boolean;
}

export const useDeviceStore = defineStore('device', {
  state: () => {
    return {
      isKeyboardVisible: false,
    } as DeviceStateInterface;
  },
  actions: {
    showKeyboard() {
      this.isKeyboardVisible = true;
    },
    hideKeyboard() {
      this.isKeyboardVisible = false;
    },
  },
});
